module.exports = __webpack_public_path__ + "resources/img/img-glassdome-omnibus-m-en.575ed0ebf560ebf659a09f61fe1537c9.png";